import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { AppRoutes } from "src/core/AppRoutes";
import { TokenAuthProvider } from "src/core/authentication/TokenAuthProvider";
import { Toaster } from "src/core/components/ui/toaster";
import { TenantProvider } from "src/core/contexts/TenantContext/TenantProvider";
import { store } from "src/core/store";

function App() {
  return (
    <Provider store={store}>
      <TokenAuthProvider>
        <BrowserRouter>
          <TenantProvider>
            <AppRoutes />
            <Toaster />
          </TenantProvider>
        </BrowserRouter>
      </TokenAuthProvider>
    </Provider>
  );
}

export default App;
